import { useTranslation } from '@/features/shared/composables/useTranslation'

const t = useTranslation()

export const profileRoutes = [
  {
    path: 'profile',
    name: 'Profile',
    component: () => import('@/features/profile/views/Profile.vue'),
    meta: {
      title: `${t('profile')} | Pour Now`,
    },
  },
]
